import { UserFilters } from '../../types/UserFilters';
import { useGetReport } from '../base/useGetReport';

export const useGetApplicationUsersReport = (userId: string, filters: UserFilters) => {
    const { downloadReport, downloadingReport } = useGetReport<UserFilters>(`applications/${userId}/users`, filters);

    return {
        downloadReport,
        downloadingReport
    };
};
